import React, { ReactElement, ReactNode } from 'react';

import { Card, CardTitle, CardSubtitle, Completion, CompletionText } from './styles';

interface TileProps {
	title: string;
	subtitle: string;
	subtotal?: number;
	total?: number;
	children?: ReactNode;
}

const Tile = (props: TileProps): ReactElement => {
	const { children, title, subtitle, subtotal, total } = props;

	return (
		<Card>
			<CardTitle>{title}</CardTitle>
			<CardSubtitle>{subtitle}</CardSubtitle>

			{ children 
				? children
				: <Completion>
					<CompletionText>
						{subtotal}/{total}
					</CompletionText>
				</Completion>
			}
		</Card>
	);
};

export default Tile;
